<template>
  <div class="view pa24">
    <div class="d-flex mb20">
      <div class="bgf7fa flex-c-c flex-column hover_pointer pl30 pt20 pb60 mr20 pr30 posre">
          <p class="fs8  cA1">{{ $t('finance', 'accountBalance') }}</p>
          <p class="fs10 fwbold cA1">{{balance}}</p>
          <div class="d-flex flex-column align-items-center w100p posab" style="top:110px">
            <div class="d-flex align-items-center">
              <p>{{ $t('finance', 'frozenCommission') }}</p>
              <el-tooltip
                class="item"
                effect="dark"
                :content="getFrozenCommissionTipText()"
                placement="top"
              >
                <i style="font-size: 16px" class="el-icon-question" />
              </el-tooltip>
              {{frozenCommission}}
            </div>
            <div class="d-flex align-items-center">
              <p class="cblue  mr10" @click="dialogTableVisible = true">{{ $t('finance', 'withdraw') }}</p>
              <p class="cblue" @click="checkRecord('moneyRecord')">{{ $t('finance', 'moneyRecord') }}</p>
            </div>
          </div>
      </div>
      <div class="flex1 h170  bgf7fa pt20 pr20 pl20 d-flex flex-column">
        <div class="flex-a-b-c mb20">
          <div class="cA1 fs8 fwbold">{{ $t('finance', 'withdrawalRecord') }}</div>
          <div class="cblue fs8 hover_pointer" @click="checkRecord('WithdrawalRecord')">{{ $t('finance', 'viewWithdrawalRecord') }}</div>
        </div>
        <div class="flex1 oyauto">
          <div class="flex-a-b-c mb20" style="padding-right: 200px" v-for="(item,index) in withdrawalList" :key="index">
            <div>{{item.createdTime}}</div>
            <div v-if="item.approvalStatus == 0">{{ getWaitingPaymentText() }}</div>
            <div v-if="item.approvalStatus == 1">{{ getPaymentSuccessText() }}</div>
            <div v-if="item.approvalStatus == 2">{{ getRejectedText() }}</div>
            <div v-if="item.approvalStatus == 3">{{ getApprovedWaitingPaymentText() }}</div>
            <div>{{item.amount + getBalanceText() + item.balance + getYuanText()}}</div>
          </div>
        </div>
        
      </div>
    </div>
    <div class="d-flex align-items-center">
      <div v-for="(item,index) in dateList"
           @click="setDay(item.date)"
           :key="index"
           class="flex-c-c w80 h34 mr10 br5 hover_pointer"
           :class=" currentDateIndex == item.date ?  'bbule1 cblue trans2' : 'bDCDFE6 trans2' ">
          {{item.name}}
      </div>
      <el-date-picker
        v-model="pickerValue"
        class="mr10 "
        align="right"
        value-format="yyyy-MM-dd"
        type="daterange"
        @change="selectDate"
        :start-placeholder="$t('marketing', 'startDate')"
        :end-placeholder="$t('marketing', 'endDate')"
      />
      <el-button type="primary" @click="queryOrders">{{ $t('marketing', 'search') }}</el-button>
    <!-- <el-button type="primary" @click="queryOrders">导出</el-button> -->
    </div>
    
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column>
          <template slot="header">
            {{ getCumulativeProductIncomeText() }}
            <el-tooltip
              class="item"
              effect="dark"
              :content="getCumulativeProductIncomeTipText()"
              placement="top"
            >
              <i style="font-size: 16px" class="el-icon-question" />
            </el-tooltip>
            {{totalSells}}
          </template>
          <el-table-column
            prop="ordersNo"
            align="center"
            :label="getOrderNumberText()"
            show-overflow-tooltip
          />
          <el-table-column prop="goodsName" align="center" :label="getProductNameText()" width="200" show-overflow-tooltip/>
        </el-table-column>
        <el-table-column :label="`${getCumulativeProductAmountText()}${totalPrice}`">
          <el-table-column prop="orderPrice" align="center" :label="getProductAmountText()" />
        </el-table-column>
        <el-table-column :label="`${getCumulativeDiscountAmountText()}${totalDiscount}`">
          <el-table-column prop="discountAmount" align="center" :label="getDiscountAmountText()">
            <template slot-scope="scope">
              {{ scope.row.discountAmount ? scope.row.discountAmount : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="payPrice" align="center" :label="getActualPaymentAmountText()"/>
        </el-table-column>
        <el-table-column :label="`${getCumulativeCommissionAmountText()}${totalCommission}`">
          <el-table-column prop="orderType" align="center" :label="getOrderTypeText()" />
          <el-table-column prop="commission" align="center" :label="getDistributionCommissionText()">
            <template slot-scope="scope">
                {{ scope.row.commission !== '0.00' ? scope.row.commission : '-' }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="forwardfNum" align="center" label="操作">
            <template>
              <div class="cblue hover_pointer">
                详情
              </div>
            </template>
          </el-table-column> -->
        </el-table-column>
        
      </template>
    </commonTable>
    <el-dialog :title="getBalanceWithdrawalText()" 
               width="40%"
               :center="true"
               :modal-append-to-body="false"
               :visible="dialogTableVisible"
               @close="dialogClose">
        <div class="pl20">
          <div class="flex-a-c  mb20">
            <div class="w200 text-align-right mr20 cA1 fs8 fwbold">
              {{ getReceivingAccountText() }}：
            </div>
            <div class="flex-a-c">
              <p class="cA1 fs8 fwbold mr40">{{payee}}</p>
              <p class="fs7">{{ getWithdrawalAccountDefaultText() }}</p>
            </div>
          </div>

          <div class="flex-a-c mb20">
            <div class="w200 text-align-right mr20 cA1 fs8 fwbold">
              {{ getWithdrawalAmountText() }}：
            </div>
            <div class="flex-a-c">
              <el-input class="mr20" v-model="withdraw" :placeholder="getWithdrawalAmountPlaceholderText()"></el-input>
              <el-button type="primary" @click="withdraw = balance">
                {{ getWithdrawAllText() }}
              </el-button>
            </div>
          </div>
          <div class="flex-a-c mb20">
            <div class="w200 text-align-right mr20 cA1 fs8 fwbold">
              {{ getMinimumWithdrawalAmountText() }}：
            </div>
            <div class="flex-a-c">
              <p class="cA1 fs8 fwbold mr40" v-if="staffs.singleLimit">{{staffs.singleLimit }}</p>
              <p class="cA1 fs8 fwbold mr40" v-else>{{0}}</p>
            </div>
          </div>
          <div class="flex-a-c mb20">
            <div class="w200 text-align-right mr20 cA1 fs8 fwbold">
              {{ getCurrentWithdrawableAmountText() }}
            </div>
            <div class="flex-a-c">
              <p class="cA1 fs8 fwbold mr40">{{balance}}</p>
            </div>
          </div>
        </div>

        <div class="mt40 flex-c-c">
          <el-button type="primary" plain @click="cancel">
            {{ getCancelText() }}
          </el-button>
          <el-button type="primary" @click="onConfirmShop">
            {{ getConfirmText() }}
          </el-button>
        </div>
    </el-dialog>

  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { getDataTimeSec } from "@/utils";
import { queryBossWithdrawalSetting, queryOrders,querySells,addBossWithdrawals,queryBossWithdrawals } from "@/api/financing";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "visitorData",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      pickerValue: "", //选择时间
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      userId: "",
      sourcesId: "",
      dateList: [
        { id: 1, name: this.getLastSevenDaysText() ,date:7 },
        { id: 2, name: this.getLastThirtyDaysText() ,date:30},
        { id: 3, name: this.getLastNinetyDaysText() ,date: 90},
      ],
      authsId: "",
      phone: "",
      currentDateIndex:0,
      dialogTableVisible:false,
      endTime:'',
      startTime:'',
      userInfo:'',
      totalCommission:'', // 累计分销佣金
      totalPrice:'', // 累计商品金额
      totalDiscount:'', // 累计优惠金额
      totalSells:'',  // 累计商品收入
      balance:0, //可提现余额
      frozenCommission: 0 ,// 冻结资金
      withdraw:'', //将要提现的金额
      staffs:'', //提现配置
      isLoading:false,
      withdrawalList:'',
      payee:''
    };
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
  },
  async created() {
    this.updateDateList();
    this.userInfo = JSON.parse(localStorage.getItem('info'))
    this.endTime = await this.getDay(0)
    this.payee = this.userInfo.userName
    this.queryBossWithdrawalSetting();
    this.queryBossWithdrawals()
    this.queryOrders();
    this.queryBossSells()
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.updateDateList();
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    // 更新日期列表的语言
    updateDateList() {
      this.dateList = [
        { id: 1, name: this.getLastSevenDaysText(), date: 7 },
        { id: 2, name: this.getLastThirtyDaysText(), date: 30 },
        { id: 3, name: this.getLastNinetyDaysText(), date: 90 },
      ];
    },
    
    // 多语言辅助方法
    getFrozenCommissionTipText() {
      return this.$t('financialStatistics', 'frozenCommissionTip');
    },
    
    getWaitingPaymentText() {
      return this.$t('financialStatistics', 'waitingPayment');
    },
    
    getPaymentSuccessText() {
      return this.$t('financialStatistics', 'paymentSuccess');
    },
    
    getRejectedText() {
      return this.$t('financialStatistics', 'rejected');
    },
    
    getApprovedWaitingPaymentText() {
      return this.$t('financialStatistics', 'approvedWaitingPayment');
    },
    
    getBalanceText() {
      return this.$t('financialStatistics', 'balanceText');
    },
    
    getYuanText() {
      return this.$t('financialStatistics', 'yuan');
    },
    
    getLastSevenDaysText() {
      return this.$t('financialStatistics', 'lastSevenDays');
    },
    
    getLastThirtyDaysText() {
      return this.$t('financialStatistics', 'lastThirtyDays');
    },
    
    getLastNinetyDaysText() {
      return this.$t('financialStatistics', 'lastNinetyDays');
    },
    
    getCumulativeProductIncomeText() {
      return this.$t('financialStatistics', 'cumulativeProductIncome');
    },
    
    getCumulativeProductIncomeTipText() {
      return this.$t('financialStatistics', 'cumulativeProductIncomeTip');
    },
    
    getOrderNumberText() {
      return this.$t('financialStatistics', 'orderNumber');
    },
    
    getProductNameText() {
      return this.$t('financialStatistics', 'productName');
    },
    
    getCumulativeProductAmountText() {
      return this.$t('financialStatistics', 'cumulativeProductAmount');
    },
    
    getProductAmountText() {
      return this.$t('financialStatistics', 'productAmount');
    },
    
    getCumulativeDiscountAmountText() {
      return this.$t('financialStatistics', 'cumulativeDiscountAmount');
    },
    
    getDiscountAmountText() {
      return this.$t('financialStatistics', 'discountAmount');
    },
    
    getActualPaymentAmountText() {
      return this.$t('financialStatistics', 'actualPaymentAmount');
    },
    
    getCumulativeCommissionAmountText() {
      return this.$t('financialStatistics', 'cumulativeCommissionAmount');
    },
    
    getOrderTypeText() {
      return this.$t('financialStatistics', 'orderType');
    },
    
    getDistributionCommissionText() {
      return this.$t('financialStatistics', 'distributionCommission');
    },
    
    getBalanceWithdrawalText() {
      return this.$t('financialStatistics', 'balanceWithdrawal');
    },
    
    getReceivingAccountText() {
      return this.$t('financialStatistics', 'receivingAccount');
    },
    
    getWithdrawalAccountDefaultText() {
      return this.$t('financialStatistics', 'withdrawalAccountDefault');
    },
    
    getWithdrawalAmountText() {
      return this.$t('financialStatistics', 'withdrawalAmount');
    },
    
    getWithdrawalAmountPlaceholderText() {
      return this.$t('financialStatistics', 'withdrawalAmountPlaceholder');
    },
    
    getWithdrawAllText() {
      return this.$t('financialStatistics', 'withdrawAll');
    },
    
    getMinimumWithdrawalAmountText() {
      return this.$t('financialStatistics', 'minimumWithdrawalAmount');
    },
    
    getCurrentWithdrawableAmountText() {
      return this.$t('financialStatistics', 'currentWithdrawableAmount');
    },
    
    getCancelText() {
      return this.$t('financialStatistics', 'cancel');
    },
    
    getConfirmText() {
      return this.$t('financialStatistics', 'confirm');
    },
    
    getNonBossPermissionErrorText() {
      return this.$t('financialStatistics', 'nonBossPermissionError');
    },
    
    getWithdrawalAmountTooLowText() {
      return this.$t('financialStatistics', 'withdrawalAmountTooLow');
    },
    
    getWithdrawalSuccessText() {
      return this.$t('financialStatistics', 'withdrawalSuccess');
    },
    
    //查询提现设置
    async queryBossWithdrawalSetting() {
      try {
        const result = await queryBossWithdrawalSetting({ id: '' });
        
        if(result.data){
          this.staffs = result.data;
        }else{
          this.staffs = {
            singleLimit:0
          }
        }
      } catch (error) {
        
        console.log(error);
      }
    },
    async queryOrders() {
      console.log(this.endTime)
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        authPhone: this.authsId,
        userId: this.userId,
        startTime: this.startTime,
        endTime: this.endTime,
      };
      try {
        this.loading = true;
        const result = await queryOrders(data);
        this.loading = false;
        if(result?.data?.pageInfo){
          const { total, list } = result.data.pageInfo;
          this.tableData = list || [];
          this.tableData.forEach(item=>{
            item.orderPrice = (item.orderPrice/100).toFixed(2)
            item.payPrice = (item.payPrice/100).toFixed(2)
            item.commission = (item.commission/100).toFixed(2)
            if(item.orderPrice !== item.orderPrice){
              item.discountAmount = item.orderPrice - item.payPrice
              
            }
          })
          this.total = total || 0;
          this.totalCommission = result.data.totalCommission || '';
          this.totalDiscount = result.data.totalDiscount || '';
          this.totalPrice = result.data.totalPrice || '';
          this.totalSells = result.data.totalSells || '';
        }else{
          this.tableData = []
          this.total = 0;
          this.totalCommission = ''
          this.totalDiscount = ''
          this.totalPrice = ''
          this.totalSells = ''
        }
        
      } catch (error) {
        this.tableData = []
        this.loading = false;
        this.total = 0;
        this.totalCommission = ''
        this.totalDiscount = ''
        this.totalPrice = ''
        this.totalSells = ''
        console.log(error);
      }
    },
    //查询余额
    queryBossSells(){
      let data = {
        ignore:true
      }
      querySells(data)
      .then(res=>{
        console.log(res)
        if (res?.data) {
          this.balance = res.data.balance ? (res.data.balance/100).toFixed(2) : '0.00';
          this.frozenCommission = res.data.frozenCommission ? (res.data.frozenCommission/100).toFixed(2) : '0.00';
        } else {
          this.balance = '0.00';
          this.frozenCommission = '0.00';
        }
      })
      .catch(err => {
        this.balance = '0.00';
        this.frozenCommission = '0.00';
        console.log(err)
      })
    },
    //获取提款记录
    queryBossWithdrawals(){
      let data = {
        pageSize: 5,
        pageNum: 1,
        isReview: 1
      }
      queryBossWithdrawals(data)
      .then(res=>{
        console.log(res)
        if (res?.data?.pageInfo?.list) {
          this.withdrawalList = res.data.pageInfo.list;
        } else {
          this.withdrawalList = [];
        }
      })
      .catch(err=>{
        this.withdrawalList = [];
        console.log(err)
      })
    },
    formatSeconds(value) {
      var theTime = parseInt(value);// 秒
      var theTime1 = 0;// 分
      var theTime2 = 0;// 小时
      if(theTime > 60) {
        theTime1 = parseInt(theTime/60);
        theTime = parseInt(theTime%60);
        if(theTime1 > 60) {
          theTime2 = parseInt(theTime1/60);
          theTime1 = parseInt(theTime1%60);
        }
      }
      var result = ""+parseInt(theTime)+this.$t('finance', 'second');
      if(theTime1 > 0) {
        result = ""+parseInt(theTime1)+this.$t('finance', 'minute')+result;
      }
      if(theTime2 > 0) {
        result = ""+parseInt(theTime2)+this.$t('finance', 'hour')+result;
      }
      return result;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryOrders()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryOrders()
    },
    dialogClose(){
      this.dialogTableVisible = false
      this.withdraw = 0
    },
    cancel(){
      this.dialogTableVisible = false
    },
    onConfirmShop(){
      if(this.isLoading == true){
        return
      }
      if(!this.userInfo.roleId){
        return this.$message.error(this.getNonBossPermissionErrorText())
      }
      this.isLoading = true

      if(this.staffs.singleLimit > this.withdraw ){
        return this.$message.error(this.getWithdrawalAmountTooLowText())
      }
      let data ={
        amount:this.withdraw
      }
      addBossWithdrawals(data)
      .then(res=>{
        if(res.code == 200){
          this.$message.success(this.getWithdrawalSuccessText())
          this.withdraw = ''
        }
        this.dialogTableVisible = false
        setTimeout(()=>{
          this.queryBossSells()
          this.isLoading = false
        },500)
      })
      .catch(err=>{
        this.dialogTableVisible = false
        setTimeout(()=>{
          this.isLoading = false
        },500)
        this.$message.error(err.message)
      })
    },
    selectDate(){
      this.currentDateIndex = ''
      this.startTime = this.pickerValue && `${this.pickerValue[0]} 00:00:00`
      this.endTime = this.pickerValue && `${this.pickerValue[1]} 23:59:59`
    },
    checkRecord(type){
      this.$router.push('/'+type)
    },
    async setDay(day){
      this.currentDateIndex = day
      this.pickerValue = ''
      this.startTime = await this.getDay(-day,'start')
      this.endTime = await this.getDay(0,"end")
      console.log(this.startTime)
      console.log(this.endTime)
    },
    getDay(day,type){
      var today = new Date();
      var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      if(type == "start"){
        return tYear+"-"+tMonth+"-"+tDate + ' 00:00:00';
      }else{
        return tYear+"-"+tMonth+"-"+tDate + ' 23:59:59';
      }
      
      
    },
    doHandleMonth(month){
      var m = month;
      if(month.toString().length == 1){
      m = "0" + month;
      }
      return m;
    }
  },
};
</script>

<style lang="scss" scoped></style>